const MAX_DRIVERS = 10;
const MIN_DRIVERS = 1;

export default { MAX_DRIVERS, MIN_DRIVERS };
